export const APP_CONFIG_PERMISSION = {
  VIEW: 'SYS_APPCONFIG_VIEW',
  ADD: 'SYS_APPCONFIG_ADD',
  EDIT: 'SYS_APPCONFIG_EDIT',
  DEL: 'SYS_APPCONFIG_DEL',
};

export const APP_CONFIG_DATA_TYPE_OPTIONS = [
  { value: 'string', label: 'Chuỗi / text' },
  { value: 'int', label: 'Số nguyên' },
  { value: 'number', label: 'Số thực' },
  { value: 'boolean', label: 'Đúng / sai' },
  { value: 'json', label: 'JSON' },
  { value: 'image', label: 'Hình ảnh' },
  { value: 'html', label: 'HTML' },
  { value: 'url', label: 'Đường dẫn' },
];

export const APP_CONFIG_ACTIVE_OPTIONS = [
  { value: 1, label: 'Kích hoạt' },
  { value: 0, label: 'Ẩn' },
];

export const APP_CONFIG_DEFAULT_VALUES = {
  key_config: '',
  value_config: '',
  description: '',
  config_type: '',
  data_type: 'string',
  is_active: 1,
};
